import { render, staticRenderFns } from "./shiftDetail.vue?vue&type=template&id=afe268d0&scoped=true&"
import script from "./shiftDetail.vue?vue&type=script&lang=js&"
export * from "./shiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./shiftDetail.vue?vue&type=style&index=0&id=afe268d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe268d0",
  null
  
)

export default component.exports